import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, message, Checkbox } from "antd";
import axios from "axios";
import { baseURL } from "./api";

const { Option } = Select;

const VendorManagement = ({ vendorData, onSubmit }) => {
  const [form] = Form.useForm();
  const isEditing = !!(vendorData && Object.keys(vendorData).length > 0);
  const [stateCode, setStateCode] = useState("");

  const states = [
    { name: "Andhra Pradesh", code: "28" }, { name: "Arunachal Pradesh", code: "12" },
    { name: "Assam", code: "18" }, { name: "Bihar", code: "10" },
    { name: "Chhattisgarh", code: "22" }, { name: "Goa", code: "30" },
    { name: "Gujarat", code: "24" }, { name: "Haryana", code: "06" },
    { name: "Himachal Pradesh", code: "02" }, { name: "Jharkhand", code: "20" },
    { name: "Karnataka", code: "29" }, { name: "Kerala", code: "32" },
    { name: "Madhya Pradesh", code: "23" }, { name: "Maharashtra", code: "27" },
    { name: "Manipur", code: "14" }, { name: "Meghalaya", code: "17" },
    { name: "Mizoram", code: "15" }, { name: "Nagaland", code: "13" },
    { name: "Odisha", code: "21" }, { name: "Punjab", code: "03" },
    { name: "Rajasthan", code: "08" }, { name: "Sikkim", code: "11" },
    { name: "Tamil Nadu", code: "33" }, { name: "Telangana", code: "36" },
    { name: "Tripura", code: "16" }, { name: "Uttar Pradesh", code: "09" },
    { name: "Uttarakhand", code: "05" }, { name: "West Bengal", code: "19" },
    { name: "Andaman and Nicobar Islands", code: "35" },
    { name: "Chandigarh", code: "04" },
    { name: "Dadra and Nagar Haveli and Daman and Diu", code: "26" },
    { name: "Lakshadweep", code: "31" }, { name: "Delhi", code: "07" },
    { name: "Puducherry", code: "34" },
  ];

  useEffect(() => {
    if (vendorData) {
      form.setFieldsValue({
        vendorId: vendorData.vendorId || "",
        vendorName: vendorData.vendorName || "",
        vendorAddress: vendorData.vendorAddress || "",
        city: vendorData.city || "",
        state: vendorData.state || "",
        gstIn: vendorData.gstIn || "",
        mobile: vendorData.mobile || "",
        phone: vendorData.phone || "",
        email: vendorData.email || "",
        paymentModes: {
          cod: vendorData?.paymentModes?.cod || false,
          online: vendorData?.paymentModes?.online || false,
        },
      });
      setStateCode(vendorData.stateCode || "");
    }
  }, [vendorData, form]);

  const handleStateChange = (value) => {
    const selected = states.find((state) => state.name === value);
    if (selected) {
      setStateCode(selected.code);
    } else {
      setStateCode("");
    }
  };

  const onFinish = async (values) => {
    const requestData = {
      vendorId: values.vendorId,
      vendorName: values.vendorName,
      vendorAddress: values.vendorAddress,
      city: values.city,
      state: values.state,
      stateCode: stateCode,
      gstIn: values.gstIn,
      mobile: values.mobile,
      phone: values.phone,
      email: values.email,
      paymentModes: {
        cod: values.paymentModes?.cod || true,
        online: values.paymentModes?.online || false,
      },
    };

    try {
      const url = isEditing
        ? `${baseURL}/editVendor/${values.vendorId}`
        : `${baseURL}/addVendor`;

      const response = isEditing
        ? await axios.put(url, requestData)
        : await axios.post(url, requestData);

      message.success(`Vendor ${isEditing ? "updated" : "added"} successfully!`);
      if (onSubmit) onSubmit(response.data);
    } catch (error) {
      console.error("Error submitting vendor:", error);
      message.error("Error submitting vendor details.");
    }
  };

  return (
    <Form
  form={form}
  layout="vertical"
  onFinish={onFinish}
  initialValues={{
    paymentModes: {
      cod: true,
      online: false,
    },
  }}
>

      <Form.Item
        name="vendorId"
        label="Distributor ID"
        rules={[{ required: true, message: "Distributor ID is required" }]}
      >
        <Input disabled={isEditing} placeholder="Distributor ID" />
      </Form.Item>

      <Form.Item
        name="vendorName"
        label="Distributor Name"
        rules={[{ required: true, message: "Please enter distributor name" }]}
      >
        <Input placeholder="eg. ABC Foods" />
      </Form.Item>

      <Form.Item
        name="mobile"
        label="Mobile Number"
        rules={[
          { required: true, message: "Please enter the mobile number" },
          { pattern: /^[6-9]\d{9}$/, message: "Mobile must be 10 digits starting with 6–9" },
        ]}
      >
        <Input placeholder="Enter mobile number" maxLength={10} />
      </Form.Item>

      <Form.Item
        name="vendorAddress"
        label="Distributor Address"
        rules={[{ required: true, message: "Please enter address" }]}
      >
        <Input.TextArea rows={2} placeholder="Street, Area" />
      </Form.Item>

      <Form.Item
        name="state"
        label="State"
        rules={[{ required: true, message: "Please select state" }]}
      >
        <Select placeholder="Select state" onChange={handleStateChange}>
          {states.map((s) => (
            <Option key={s.code} value={s.name}>
              {s.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="city"
        label="City"
        rules={[{ required: true, message: "Please enter city" }]}
      >
        <Input placeholder="Enter city" />
      </Form.Item>

      <Form.Item
        name="gstIn"
        label="GSTIN/UIN"
        rules={[
          { required: true, message: "Please enter GSTIN/UIN" },
          { pattern: /^[A-Z0-9]{15}$/, message: "GSTIN must be 15 uppercase characters" },
        ]}
      >
        <Input placeholder="Enter GSTIN/UIN" maxLength={15} />
      </Form.Item>

      <Form.Item
        name="phone"
        label="Phone Number"
        rules={[
          {
            pattern: /^[0-9]{6,15}$/,
            message: "Phone number should be 6–15 digits",
          },
        ]}
      >
        <Input placeholder="Optional phone number" maxLength={15} />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: "Please enter an email" },
          { type: "email", message: "Enter valid email" },
        ]}
      >
        <Input placeholder="Enter email address" />
      </Form.Item>

      <Form.Item
  label="Payment Modes"
  shouldUpdate
  required
  style={{ marginBottom: 16 }}
>
  {() => (
   <Form.Item>
  <div>
    <Form.Item name={["paymentModes", "online"]} valuePropName="checked" noStyle>
      <Checkbox>Online Payment</Checkbox>
    </Form.Item>
    <Form.Item name={["paymentModes", "cod"]} valuePropName="checked" noStyle>
      <Checkbox style={{ marginLeft: 16 }}>Cash on Delivery</Checkbox>
    </Form.Item>
  </div>
</Form.Item>


  )}
</Form.Item>



      <Form.Item>
        <Button type="primary" htmlType="submit">
          {isEditing ? "Update Distributor" : "Add Distributor"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default VendorManagement;
